'use client'

import type { NavigationHeaderProps } from '@maestro/commerce-blocks/components/navigation-header/navigation-header.types'

import {
  NavigationDesktop,
  NavigationMobile,
} from '@maestro/commerce-blocks/components/navigation-header'
import { useNavigationHeaderStandard } from '@maestro/commerce-blocks/components/navigation-header/batons/use-navigation-header-standard'

export default function NavigationHeaderStandard(props: NavigationHeaderProps) {
  const { customClassName, menu, shortcuts } = props
  const { closeMenu, isOpen } = useNavigationHeaderStandard()

  return (
    <>
      {/* Always rendered (not gated on isMobileView) so SSR and client produce
          identical DOM and avoid a hydration mismatch. */}
      <NavigationMobile
        closeMenu={closeMenu}
        menu={menu}
        shortcuts={shortcuts}
        isOpen={isOpen}
      />
      {/* First level of desktop menu must always be rendered to avoid CLS. Display is handled via CSS. */}
      <NavigationDesktop menu={menu} customClassName={customClassName} />
    </>
  )
}
